import { useRef, useCallback } from "react";

export function useFormFocusFlow() {
  const refs = useRef([]);

  const register = useCallback((index) => (el) => {
    if (el) {
      refs.current[index] = el;
    }
  }, []);

  const focusNext = useCallback((index) => {
    const next = refs.current[index + 1];
    if (next && typeof next.focus === "function") {
      next.focus();
    }
  }, []);

  const clickNext = useCallback((index) => {
    const next = refs.current[index + 1];
    if (next && typeof next.focus === "function") {
      next.click();
    }
  }, []);

  return { register, focusNext, clickNext };
}